export function getDomain() {
  let domain;
  if (window) {
    const fulldomain = window.location.hostname.split('.');
    let found = false;
    domain = fulldomain
      .reduce((d, part, i) => {
        if (part.includes('pluto')) {
          found = true;
        }
        if (!found) {
          return d;
        }
        return `${d}.${part}`;
      }, '')
      .substr(1);
  }
  return domain;
}
